// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e617e620","239":"d81af4d9","732":"155538a3"}[chunkId] + ".chunk.js";
};